import type { FC } from "react";
import { DashboardCardContent } from "web_myplann/Dashboard/Components/DashboardCardContent";
import { DashboardCardSlot } from "web_myplann/Dashboard/Components/DashboardCardSlot";
import type { DashboardType } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import type { AnimationDirection } from "web_myplann/Dashboard/Hooks/useDashboardAnimation";
import { useDashboardCardSlots } from "web_myplann/Dashboard/Hooks/useDashboardCardSlots";

type Props = {
	dashboard: DashboardType;
	direction: AnimationDirection;
	isDashboardDetail?: boolean;
	navigateToDashboardDetail?: () => void;
	onTooltipToggle?: (open: boolean) => void;
};

const SLOT_INDEXES = [0, 1] as const;

export const DashboardCardSlider: FC<Props> = ({
	dashboard,
	direction,
	isDashboardDetail,
	navigateToDashboardDetail,
	onTooltipToggle,
}) => {
	const { slots, frontSlot, isEntering, getSlotTransform } =
		useDashboardCardSlots(dashboard, direction);

	return (
		<>
			{SLOT_INDEXES.map((slotIndex) => (
				<DashboardCardSlot
					key={slotIndex}
					transform={getSlotTransform(slotIndex)}
					isAnimated={!isEntering}
					isFront={slotIndex === frontSlot}
				>
					<DashboardCardContent
						dashboardData={slots[slotIndex]}
						isDashboardDetail={isDashboardDetail}
						navigateToDashboardDetail={navigateToDashboardDetail}
						onTooltipToggle={
							slotIndex === frontSlot ? onTooltipToggle : undefined
						}
					/>
				</DashboardCardSlot>
			))}
		</>
	);
};
